export default "__VITE_ASSET__CymHTnLJ__"